/**
 * RadioButton.base
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
var RadioButtonBase = function (props) {
    var id = props.id, name = props.name, value = props.value, className = props.className, disabled = props.disabled, defaultChecked = props.defaultChecked, checked = props.checked, fieldRef = props.fieldRef, ariaDescribedby = props.ariaDescribedby, ariaInvalid = props.ariaInvalid, onChange = props.onChange, _a = props.theme, theme = _a === void 0 ? 'teal' : _a, children = props.children, htmlAttributes = __rest(props, ["id", "name", "value", "className", "disabled", "defaultChecked", "checked", "fieldRef", "ariaDescribedby", "ariaInvalid", "onChange", "theme", "children"]);
    return (React.createElement("div", { className: clsx(className, 'radio__wrapper flex items-center') },
        React.createElement("label", { htmlFor: id, className: clsx('flex items-center px-1 text-p leading-5 transition-all duration-300', disabled && 'opacity-50') },
            React.createElement("input", __assign({ type: "radio", id: id, name: name, value: value, disabled: disabled, className: clsx('sr-only radio', theme === 'teal' && 'radio--teal'), defaultChecked: defaultChecked, checked: checked, ref: fieldRef, onChange: onChange, "aria-describedby": ariaDescribedby, "aria-invalid": ariaInvalid }, htmlAttributes)),
            React.createElement("span", { className: clsx('tab-focus-selector relative inline-block w-5 h-5 mr-2 rounded-full rounded-sm border-2 border-grey transition-all duration-300 hover:bg-greyLighter-hover', !disabled && 'cursor-pointer hover:bg-greyLighter', theme === 'teal' && 'radio__icon--teal') }),
            children)));
};
export default RadioButtonBase;
